const dict = {
	custom: {
		check_rgpd: {
			required: () => gettext('Veuillez cocher les deux cases pour accéder à l\'étape suivante')
		},
		check_validation: {
			required: () => gettext("Vous devez accepter les conditions d'utilisation")
		}
	}
};
